import type { Theme } from "@mui/material";
import type { InspirationStat } from "web_myplann/Inspiration/Types/InspirationTypes";

export const getInspirationStatColors = (
	theme: Theme,
	tone: InspirationStat["tone"],
) =>
	tone === "highlight"
		? {
				bg: theme.palette.blue[50],
				labelColor: theme.palette.blue.main,
				amountColor: theme.palette.blue.main,
			}
		: {
				bg: theme.palette.surface.muted,
				labelColor: theme.palette.grey[500],
				amountColor:
					tone === "negative"
						? theme.palette.red.main
						: theme.palette.green.main,
			};
